// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"2c23fac1","517":"38cc481c"}[chunkId] + ".chunk.js";
};